import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const PayOffPartner = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default PayOffPartner;